const FormType = ["Callback", "Care", "Job", "Tour"];
const Source = ["Dealer Site", "Sell Car"];
const Status = ["New", "Messaged", "Acknowledged"];
const Type = ["Task", "Notes"];
const TypeOfRooms = [
  "Foyer/Entrance Hall",
  "Kitchen Room",
  "Family Room",
  "Dining Room",
  "Living Room",
  "Master Bedroom",
  "Laundry Room",
];
const Stage = [
  "Prospecting",
  "First Contact",
  "Viewing",
  "Viewing Outcome",
  "Assessment",
  "Assessment Outcome",
  "Closed",
];
const Outcome = ["Won", "Lost"];
const CareFor = [
  "Myself",
  "A parent",
  "A partner",
  "Another family member",
  "A friend",
  "A client",
];
const CareRequired = [
  "Immediately",
  "1 week - 1 month",
  "1-3 month",
  "3-6 month",
  "6 months +",
];
const CareFunding = [
  "Self Funding (Private)",
  "Local Authority with Top Up",
  "Local Authority",
  "NHS Continuing Healthcare (CHC)",
  "Other",
];
const CareType = [
  "Older person residential",
  // "Older person residential dementia",
  "Older person nursing",
  // "Older person nursing dementia",
  "Other types of care",
];
const CareLength = ["Permanent/Long-term", "Respite/Short-term"];

const GenderList = [
  "Male",
  "Female",
  // "Non-Binary",
  // "Gender Queer",
  // "Gender Fluid",
  // "Transgender",
  "Prefer not to say",
];
const SourceList = [
  "Inbound call",
  "Outbound call",
  "Walk in",
  "Email",
  "Website",
  "Voicemail",
  "Live chat",
  "Care Hearth",
  "Other",
];
const ReasonList = [
  "No longer looking",
  "Package declined",
  "No beds available",
  "Disliked service",
  "Service not suitable",
  "Lost contact",
  "Deceased",
  "Mystery shopper",
  "Found alternative placement",
  "Unable to meet residence needs",
  "Duplicate",
  "Home is too far",
];
const ReasonListColors = {
  Nolongerlooking: `#EB984E`,
  Packagedeclined: `#F0B27A`,
  Nobedsavailable: `#F7DC6F`,
  Dislikedservice: `#F1948A`,
  Servicenotsuitable: `#C39BD3`,
  Lostcontact: `#BFC9CA`,
  Deceased: `#85929E`,
  Mysteryshopper: `#EAEDED`,
  Foundalternativeplacement: `#D6EAF8`,
  Duplicate: `#D7DBDD`,
  Unabletomeetresidenceneeds: `#ff0000`,
  Homeistoofar: `#ff8b8b`,
};
const TitleList = ["Mr", "Mrs", "Miss"];
const ReminderTypes = [
  `Follow-up phone call`,
  `Ready Showroom`,
  `Pre Assessment call`,
];
const FundingPriorities = ["Urgent", "Planned"];

export {
  FormType,
  Source,
  Status,
  Type,
  TypeOfRooms,
  Stage,
  Outcome,
  CareFor,
  CareRequired,
  CareFunding,
  CareType,
  CareLength,
  GenderList,
  SourceList,
  ReasonList,
  ReasonListColors,
  TitleList,
  ReminderTypes,
  FundingPriorities,
};
